import { LeftOutlined } from '@ant-design/icons'
import { isMobile } from 'react-device-detect'
import './Privacy.scss'
import { HOME } from 'configs/path'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { bindParams, readFileTxt } from 'utilities/helpers'
import { useAppSelector } from 'hooks'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
const PrivacyPage = () => {
  const { setting, app_id } = useAppSelector((s) => s.app)
  const [content, setContent] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    readFileTxt(setting.privacy_file_url, (value: string) => setContent(value))
  }, [setting.privacy_file_url])
  return (
    <div className="privacy-page">
      <Helmet>
        <title>{setting?.app_name}</title>
      </Helmet>
      {isMobile && (
        <div className="privacy-header">
          <Link to={bindParams(HOME, {
            app: app_id
          })}>
            <LeftOutlined />
          </Link>
          <p>{t('privacy')}</p>
        </div>
      )}
      <div
        className="privacy-content"
        dangerouslySetInnerHTML={{
          __html: content
        }}
      ></div>
    </div>
  )
}

export default PrivacyPage